import { Component, Input } from '@angular/core';
import { AiChatItem, AiChatMessageItem } from '@app/core/services/ai-chat.types';

@Component({
    selector: 'tt-ai-chat-workspace',
    templateUrl: './ai-chat-workspace.component.html',
    styleUrls: ['./ai-chat-workspace.component.css'],
    standalone: false,
})
export class AiChatWorkspaceComponent {
    @Input()
    public selectedConversation?: AiChatItem;

    @Input()
    public messages: AiChatMessageItem[] = [];

    @Input()
    public loading = false;

    @Input()
    public loadingMessages = false;

    @Input()
    public sending = false;
}
